// 练习题数据 — 从题库导入并按章节/题型挂载
// answer: 0=A, 1=B, 2=C, 3=D

import { questionBank } from './question_bank';
import { listeningReadingQuestions } from './question_listen2';

export const questions = {
  // 第5章：BJT模拟试卷 — 使用完整题库
  5: {
    listening: questionBank.listening,
    listeningReading: questionBank.listeningReading,
    reading: questionBank.reading,
  },
  // 第6章：BJT模拟试卷 — 使用完整题库（同第5章）
  6: {
    listening: questionBank.listening,
    listeningReading: questionBank.listeningReading,
    reading: questionBank.reading,
  },
};
